import { CSSProperties } from 'react'

const styles: {
  container: CSSProperties
  backdrop: CSSProperties
  elevated: CSSProperties
} = {
  container: {
    display: 'flex',
    position: 'absolute',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
  },
  backdrop: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundColor: 'black',
    opacity: 0.6,
  },
  elevated: {
    zIndex: 2,
  },
}

export default styles
